var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.frame ? _c('div', {
    staticClass: "absolute-fill frame",
    class: [_vm.frame]
  }, [!_vm.only || _vm.only == 'background' ? _c('div', {
    staticClass: "absolute-fill background",
    style: _vm.style,
    domProps: {
      "innerHTML": _vm._s(_vm.svgBackground)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "absolute-fill midground",
    class: {
      'overflow-hidden': _vm.hasCrop
    },
    style: {
      'mask-image': _vm.mask
    }
  }, [_vm._t("default")], 2), !_vm.only || _vm.only == 'foreground' ? [_vm.svgForeground ? _c('div', {
    staticClass: "absolute-fill foreground",
    style: _vm.style,
    domProps: {
      "innerHTML": _vm._s(_vm.svgForeground)
    }
  }) : _c('div', {
    staticClass: "absolute-fill foreground",
    style: _vm.style
  }, [_c('div', {
    staticClass: "edge left"
  }), _c('div', {
    staticClass: "edge right"
  }), _c('div', {
    staticClass: "edge top"
  }), _c('div', {
    staticClass: "edge bottom"
  }), _c('div', {
    staticClass: "corner top-left"
  }), _c('div', {
    staticClass: "corner top-right"
  }), _c('div', {
    staticClass: "corner bottom-left"
  }), _c('div', {
    staticClass: "corner bottom-right"
  })])] : _vm._e()], 2) : _c('div', {
    staticClass: "absolute-fill midground",
    class: {
      'overflow-hidden': _vm.hasCrop
    }
  }, [_vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }